import { createDefaultTyrann } from '@apis/common';
import { currencyRate } from '@models/CurrencyRate';
import * as t from 'io-ts';

export const exchangeCalendarApis = createDefaultTyrann({
  '/exchange-calendar/': {
    get: {
      query: t.type({
        start: t.string,
        end: t.string,
        pair: t.string,
      }),
      response: {
        200: t.array(currencyRate),
      },
    },
  },
});
